/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * This widget allows you to manage many search boxes.
 *
 * @class RouteInputs
 * @namespace L
 * @extends L.Control
 * @uses L.Evented
 * @module Widgets
 * @constructor
 * @param {Object} [options] Options to be passed to the routeInputs control
 * @param {Number} [options.searchBoxes=2] Number of searchBoxes to be created
 * @param {"topright"|"topleft"|"bottomright"|"bottomleft"} [options.position="topleft"] Position of
 *     the control on the map
 * @param {String} [options.location=L.RouteInputs.Location.Start] Definition of place of creation location control.
 *     Should be equal to one of the values in the {{#crossLink "L.RouteInputs/Location:property"}}{{/crossLink}}
 *     property.
 * @param {String} [options.enableSearchBoxesModifcation=false] Determines whether control should expose
 *     functionality of adding or removing waypoints by internal controls
 * @param {String} [options.waypointPlacement=L.RouteInputs.WaypointPlacement.BeforeLast] Determines the place where
 *     the new waypoint will added to.
 *     Should be equal to one of the values in the
 *     {{#crossLink "L.RouteInputs/WaypointPlacement:property"}}{{/crossLink}} property.
 * @param {Object} [options.searchOptions] Options for the {{#crossLink "L.SearchBox"}}{{/crossLink}} instances
 * @param {Object} [options.searchOptions.collapsible=false] Decide if the search boxes should be collapsed
 *
 * @example
 * ```javascript
 * // Route inputs with two search boxes and location control
 * var widget = new L.RouteInputs({
 *   searchBoxes: 2,
 *   location: L.RouteInputs.Location.Start
 * })
 * widget.addTo(map);
 * ```
 */
/* jshint nomen:false */
define(['display/map', 'services/utils', 'widgets/controls/searchBox'], function(L, utils) {
    'use strict';

    var EVENTS = {
            LocationsFound: 'locationsFound',
            LocationsCleared: 'locationsCleared',
            LocationError: 'locationError'
        }, LOCATION = {
            Start: 'start',
            End: 'end'
        }, WAYPOINT_PLACEMENT = {
            Last: 'last',
            BeforeLast: 'beforeLast'
        };
    var routeInputConstructor;

    /**
     * @ignore
     * Returns the list of selected locations.
     * @return {Array}
     */
    function getLocationsFromSearchBoxes() {
        return this.searchBoxes.map(function(searchBox) {
            return searchBox.selectedLocation;
        });
    }

    function updateSearchBoxIcons() {
        var self = this;
        self.searchBoxes.forEach(function(searchBox, index) {
            var style = self.getIconClassName(index);
            searchBox.setIcon(style);
        });
    }

    function updateLocationButton() {
        var locationIconIndex;
        this.searchBoxes.forEach(function(searchBox) {
            searchBox.removeLocationIcon();
        });
        locationIconIndex = this.options.location === LOCATION.Start ? 0 : this.searchBoxes.length - 1;
        this.searchBoxes[locationIconIndex].addLocationIcon();
    }

    function showDeleteSearchBoxButton(searchBox) {
        if (searchBox.deleteIcon === undefined) {
            searchBox.deleteIcon = L.DomUtil.create('div', 'icon-trash-black leaflet-control-routeInputs-remove');
            searchBox._container.insertBefore(searchBox.deleteIcon, searchBox.resultsContainer);
            L.DomEvent.on(searchBox.deleteIcon, 'click', function() {
                this.removeInput(searchBox);
            }, this);
        }
    }

    function hideDeleteSearchBoxButton(searchBox) {
        if (searchBox.deleteIcon !== undefined) {
            searchBox.deleteIcon.parentNode.removeChild(searchBox.deleteIcon);
            searchBox.deleteIcon = undefined;
        }
    }

    function setVisibilityForDeleteButton(callback) {
        var i;
        for (i = 0; i < this.searchBoxes.length; i += 1) {
            callback.call(this, this.searchBoxes[i]);
        }
    }

    function updateDeleteSearchBoxButtons() {
        if (this.options.enableSearchBoxesModifcation === true) {
            if (this.searchBoxes.length === this.options.searchBoxes) {
                setVisibilityForDeleteButton.call(this, hideDeleteSearchBoxButton);
            } else {
                setVisibilityForDeleteButton.call(this, showDeleteSearchBoxButton);
            }
        }
    }

    function showInsertSearchBoxButton(container) {
        if (this.insertSearchBoxButton === undefined) {
            this.insertSearchBoxButton = L.DomUtil.create('div',
                'icon-add-black leaflet-control-routeInputs-add',
                container || this.getContainer());
            L.DomEvent.on(this.insertSearchBoxButton, 'click', this.addInput, this);
        }
    }

    function hideInsertSearchBoxButton() {
        if (this.insertSearchBoxButton !== undefined) {
            L.DomEvent.off(this.insertSearchBoxButton, 'click', this.addInput);
            this.insertSearchBoxButton.parentNode.removeChild(this.insertSearchBoxButton);
            this.insertSearchBoxButton = undefined;
        }
    }

    function updateInsertSearchBoxButton() {
        var i;
        if (this.options.enableSearchBoxesModifcation === true) {
            for (i = 0; i < this.searchBoxes.length; i += 1) {
                if (this.searchBoxes[i].input.value.length === 0) {
                    hideInsertSearchBoxButton.call(this);
                    return;
                }
            }
            showInsertSearchBoxButton.call(this, null);
        }
    }

    L.RouteInputs = L.Control.extend({

        includes: L.Evented.prototype,

        statics: {
            Events: EVENTS,
            Location: LOCATION,
            WaypointPlacement: WAYPOINT_PLACEMENT
        },

        options: {
            searchBoxes: 2,
            position: 'topleft',
            location: LOCATION.Start,
            enableSearchBoxesModifcation: false,
            waypointPlacement: WAYPOINT_PLACEMENT.BeforeLast,
            searchOptions: {
                collapsible: false
            }
        },

        initialize: function(options) {
            if (options !== undefined && options.searchOptions !== undefined) {
                utils.addFields(options.searchOptions, this.options.searchOptions);
                delete options.searchOptions;
            }
            L.Util.setOptions(this, options);
            this.searchBoxes = [];
        },

        onAdd: function() {
            var i, container = this.createContainer();
            this.searchBoxesContainer = L.DomUtil.create('div', 'leaflet-control-search-boxes', container);
            for (i = 0; i < this.options.searchBoxes; i += 1) {
                this.searchBoxes.push(this.createSearchBox(i));
            }
            return container;
        },

        /**
         * Method used to create the container for the search boxes.
         *
         * @method createContainer
         * @return {HTMLElement} Container for search boxes
         */
        createContainer: function() {
            var container = L.DomUtil.create('div', 'leaflet-control-routeInputs');
            L.DomEvent.disableClickPropagation(container);
            L.DomEvent.disableScrollPropagation(container);
            return container;
        },

        /**
         * Method used to get search box icon's class name, depending on its position (index).
         *
         * The returned class name should be added to the input.
         *
         * @method getIconClassName
         * @param {Number} index
         * @return {String}
         */
        getIconClassName: function(index) {
            var className = 'icon-flag-black',
                minimumBoxesAchieved = this.options.searchBoxes > this.searchBoxes.length,
                lastSearchBoxIndex = minimumBoxesAchieved ? this.options.searchBoxes - 1 : this.searchBoxes.length - 1;
            if (index === 0) {
                className = 'icon-start-black';
            } else if (index === lastSearchBoxIndex) {
                className = 'icon-end-black';
            }
            return className;
        },

        /**
         * Method used to initialize search box by adding element to the container and applying event handlers on
         * it.
         *
         * @method createSearchBox
         * @param {Number} index Index of the search box (starting from `0`)
         * @return {L.SearchBox} Modified search box object
         */
        createSearchBox: function(index) {
            var searchBoxInstance;
            var options = utils.clone(this.options.searchOptions);
            options.location = this.needsLocationIcon(index);
            options.icon = this.getIconClassName(index);
            options.searchOnDragEnd = 'open';
            searchBoxInstance = (new L.SearchBox(options)).addTo(this._map);

            this.searchBoxesContainer.insertBefore(
                searchBoxInstance.getContainer(),
                this.searchBoxesContainer.childNodes[index]);
            this.addSearchBoxEventHandlers(searchBoxInstance);
            return searchBoxInstance;
        },

        /**
         * Method used to remove given search box from the view by specific index.
         *
         * @method removeSearchBox
         * @param {Number} index Index of the search box (starting from `0`)
         * @return {L.SearchBox} Modified search box object
         */
        removeSearchBox: function(index) {
            var searchBox = this.searchBoxesContainer.childNodes[index];
            searchBox.parentNode.removeChild(searchBox);
            return searchBox;
        },

        /**
         * Method used to check if search box needs location element.
         *
         * @method needsLocationIcon
         * @param {Number} searchBoxIndex Index of the given search box (starting from `0`)
         * @return {Boolean} Returns information of presence of location element
         */
        needsLocationIcon: function(searchBoxIndex) {
            var first = this.options.location === LOCATION.Start && searchBoxIndex === 0,
                last = this.options.location === LOCATION.End && searchBoxIndex === this.options.searchBoxes - 1;
            return first || last;
        },

        /**
         * Method used to add handlers for given search box. If obtaining user's current location fails,
         * {{#crossLink "L.RouteInputs/LocationError:event"}}{{/crossLink}} is fired.
         *
         * @method addSearchBoxEventHandlers
         * @param {L.SearchBox} searchBox Search box instance used to add handlers on it
         */
        addSearchBoxEventHandlers: function(searchBox) {
            var that = this;
            searchBox.on(searchBox.Events.ResultClicked, function(eventObject) {
                that.onLocationChange(eventObject);
            });
            searchBox.on(searchBox.Events.ClearButtonClicked, function(eventObject) {
                that.onLocationChange(eventObject);
                updateInsertSearchBoxButton.call(that);
            });
            searchBox.on(searchBox.Events.SearchInputChanged, function() {
                updateInsertSearchBoxButton.call(that);
            });
            if (searchBox.getLocation()) {
                searchBox.getLocation().on(searchBox.getLocation().Events.LocationError, function(eventObject) {
                    that.fire(this.Events.LocationError, eventObject);
                });
            }
        },

        /**
         * Method used to manage changing state of search boxes. Depending on the content of the searchBox, there might
         * be fired one of these two events:
         *  - {{#crossLink "L.RouteInputs/LocationsFound:event"}}{{/crossLink}} or
         *  - {{#crossLink "L.RouteInputs/LocationsCleared:event"}}{{/crossLink}}
         *
         * @method onLocationChange
         * @param {Object} eventObject Object that contains event's information
         * @param {L.SearchBox} eventObject.target Box instance
         * @param {Object} eventObject.data
         * @param {Number} eventObject.data.position Position of the box
         */
        onLocationChange: function(eventObject) {
            var searchBox = eventObject.target;
            searchBox.selectedLocation = eventObject.data ? eventObject.data.position : undefined;

            this.fire(eventObject.data ? this.Events.LocationsFound : this.Events.LocationsCleared, {
                points: getLocationsFromSearchBoxes.call(this)
            });
        },

        /**
         * Method used to show notification when looking for current location fails.
         *
         * @method showLocationNotFoundMessageBox
         */
        showLocationNotFoundMessageBox: function() {
            L.messageBox({closeAfter: 1500}).openOn(this._map).setContent('Could not find your location');
        },

        /**
         * Method used to add searchBox to the specific position (index).
         *
         * @method addInput
         * @param {Number} [index] Represents position where search box should be added to.
         *     Not passing any index will cause adding a searchBox at the end of list or just before the last
         *     search box.
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map);
         * widget.addInput(0);
         * widget.addInput();
         * ```
         */
        addInput: function(index) {
            if (!isFinite(index)) {
                index = this.searchBoxes.length;
                if (this.options.waypointPlacement === WAYPOINT_PLACEMENT.BeforeLast) {
                    index -= 1;
                }
            }
            this.searchBoxes.splice(index, 0, this.createSearchBox(index));
            updateSearchBoxIcons.call(this);
            updateLocationButton.call(this);
            updateDeleteSearchBoxButtons.call(this);
            updateInsertSearchBoxButton.call(this);
        },

        /**
         * Method used to remove searchBox from the specific position (index).
         *
         * @method removeInput
         * @param {Number|L.SearchBox} searchBox The index of the searchBox to be deleted or the box instance itself
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map)
         * widget.removeInput(0);
         * widget.removeInput();
         * ```
         */
        removeInput: function(searchBox) {
            var nodeList;
            if (searchBox === undefined) {
                searchBox = this.searchBoxes.length - 1;
            } else if (typeof searchBox === 'object') {
                nodeList = Array.prototype.slice.call(this.searchBoxesContainer.children);
                searchBox = nodeList.indexOf(searchBox.getContainer());
            }
            this.removeSearchBox(searchBox);
            this.searchBoxes.splice(searchBox, 1);
            updateSearchBoxIcons.call(this);
            updateLocationButton.call(this);
            updateDeleteSearchBoxButtons.call(this);
            updateInsertSearchBoxButton.call(this);

            this.fire(this.Events.LocationsCleared, {points: getLocationsFromSearchBoxes.call(this)});
        },

        /**
         * Event that is fired when locations in all searchBoxes are changing.
         *
         * @event LocationsFound
         * @param {Array} points Array of points that represents locations from all searchBoxes, even if they are
         *     undefined.
         * @param {String} [type="locationsFound"] Event's name
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         * var routeInputInstance = (new L.RouteInputs()).addTo(map);
         * routeInputInstance.on(L.RouteInputs.Events.LocationsFound, function (eventObject) {
         *      console.log(eventObject.points);
         * });
         * ```
         */

        /**
         * Event that is fired when locations in all searchBoxes are being removed.
         *
         * @event LocationsCleared
         * @param {Array} points Array of points that represents locations from all searchBoxes, even if they are
         *     undefined.
         * @param {String} [type="locationsCleared"] Event's name
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map);
         * widget.on(L.RouteInputs.Events.LocationsCleared, function (eventObject) {
         *   console.log(eventObject.points);
         * });
         * ```
         */

        /**
         * Event that is fired when obtaining user's current location fails.
         *
         * @event LocationError
         * @param {Object} eventObject All failure information
         * @param {String} [type="locationError"] Event's name
         * @param {Element} target Event's target.
         *
         * @example
         * ```javascript
         * var widget = new L.RouteInputs();
         * widget.addTo(map);
         * widget.on(L.RouteInputs.Events.LocationError, function (eventObject) {
         *   console.log(eventObject);
         * });
         * ```
         */
        Events: EVENTS
    });

    routeInputConstructor = function(options) {
        var routeInputs = new L.RouteInputs(options);
        utils.addDeprecatedProperty(routeInputs, 'Event', 'Events');
        return routeInputs;
    };

    /**
     * Determines the position that location icon will be added to.
     *
     * Possible options are:
     *
     * * `Location.Start` - location will be added to the first searchBox in the list.
     * * `Location.End` - location will be added to the last searchBox in the list.
     *
     * @property {Object} Location
     *
     * @example
     * ```javascript
     * var widget = new L.RouteInputs({
     *   location: L.RouteInputs.Location.Start
     * });
     * widget.addTo(map);
     * ```
     */
    routeInputConstructor.Location = LOCATION;

    /**
     * Determines the position where waypoint will be added to.
     *
     * Possible options are:
     *
     * * `WaypointPlacement.BeforeLast` - new waypoint will be added before the last searchBox.
     * * `WaypointPlacement.Last` - new waypoint will be added as the last element in the list.
     *
     * @property {Object} WaypointPlacement
     *
     * @example
     * ```javascript
     * var widget = new L.RouteInputs({
     *   waypointPlacement: L.RouteInputs.WaypointPlacement.BeforeLast
     * });
     * widget.addTo(map);
     * ```
     */
    routeInputConstructor.WaypointPlacement = WAYPOINT_PLACEMENT;

    return routeInputConstructor;
});



// WEBPACK FOOTER //
// ./widgets/controls/routeInputs.js